<div class="modal-header">
  <h3>Blocked Tax IDs</h3>
  <button
    type="button"
    class="btn-close"
    aria-label="Close"
    (click)="close()"
  ></button>
</div>

<div class="modal-body">
  <div class="card mb-3">
    <div class="card-header">
      <h5 class="mb-0">Add New Blocked Tax ID</h5>
    </div>
    <div class="card-body">
      <form [formGroup]="addForm" (ngSubmit)="addBlockedTaxId()">
        <div class="row">
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Tax ID Type</label>
              <select
                class="form-control"
                formControlName="taxIdType"
                title="Tax ID Type"
              >
                @if (isCanada) {
                  <option value="GST_HST">GST/HST</option>
                } @else {
                  <option value="EIN">EIN</option>
                  <option value="SSN">SSN</option>
                }
              </select>
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Tax ID</label>
              <input
                type="text"
                class="form-control"
                formControlName="taxId"
                [inputMask]="currentMask"
              />
            </div>
          </div>
          <div class="col-md-4">
            <div class="form-group">
              <label class="form-label">Note (optional)</label>
              <input
                type="text"
                class="form-control"
                formControlName="note"
                placeholder="Reason for blocking"
              />
            </div>
          </div>
        </div>
        <div class="row mt-2">
          <div class="col-12 text-end">
            <button type="submit" class="btn btn-primary">
              Add to blocklist
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>

  <div class="card">
    <div class="card-header">
      <h5 class="mb-0">Current Blocked Tax IDs ({{ blockedTaxIds.length }})</h5>
    </div>
    <div class="card-body">
      @if (blockedTaxIds.length === 0) {
        <div class="text-center text-muted py-3">
          No blocked tax IDs for this client.
        </div>
      } @else {
        <table class="table table-striped">
          <thead>
            <tr>
              <th>Type</th>
              <th>Tax ID</th>
              <th>Note</th>
              <th>Date Added</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (item of blockedTaxIds; track item.id) {
              <tr>
                <td>
                  <span
                    class="badge"
                    [class.bg-primary]="
                      item.taxIdType === 'EIN' || item.taxIdType === 'GST_HST'
                    "
                    [class.bg-secondary]="item.taxIdType === 'SSN'"
                  >
                    {{ getTypeLabel(item.taxIdType) }}
                  </span>
                </td>
                <td>{{ formatTaxId(item.taxId, item.taxIdType) }}</td>
                <td>{{ getNoteText(item) }}</td>
                <td>{{ formatDate(item.createdAt) }}</td>
                <td>
                  <button
                    class="btn btn-sm btn-danger"
                    (click)="deleteBlockedTaxId(item.id)"
                  >
                    Remove
                  </button>
                </td>
              </tr>
            }
          </tbody>
        </table>
      }
    </div>
  </div>
</div>

<div class="modal-footer">
  <button class="btn btn-secondary" (click)="close()">Close</button>
</div>
